<template>
	<div class="ReportPrint">
		<div class="ReportPrint-instructions">
			<p class="Heading Heading--h2">Print or save as PDF</p>
			<p class="u-stack-sm">You may print or save your Trip Report as a PDF using this simplified page layout. Please allow your Trip Report to fully load before printing or saving. Large trip reports may take some time to load.</p>
			<div class="ReportPrint-instructions-actions">
				<a :href="`${baseUrl}tripreport/${tripReportId}`" class="Button Button--hollow">Back</a>
				<button @click="print" class="Button">Open Print Dialog</button>
			</div>
		</div>
		<div class="ReportPrint-heading">
			<span class="Heading Heading--h3">eBird Trip Reports</span>
			<!-- eBird Logo was here -->
		</div>
		<CloDivider size="sm"/>
	</div>
</template>

<script>
import Vue from 'vue';
import CloHeading from '@/base/CloHeading/CloHeading.vue';
import CloButton from '@/base/CloButton/CloButton.vue';
import CloDivider from '@/base/CloDivider/CloDivider.vue';
export default {
	name: 'ReportPrint',
	components: {
		CloHeading,
		CloButton,
		CloDivider,
	},
	props: {
		tripReportId: Number,
	},
	data() {
		return {
			baseUrl: window.baseUrl,
		};
	},
	methods: {
		print() {
			console.log("Opening print dialog...");
			window.print();
		}
	}
};
</script>

<style lang="scss">
.print {
	.ReportPrint {
		margin: $space-md 0;
	}
	.ReportPrint-instructions {
		margin: $space-lg 0;
		@include inset-md;
		outline: 1px dashed $color-neutral-1;
		border-radius: $radius-sm;
	}
	.ReportPrint-instructions-actions {
		display: flex;
		align-items: center;
		justify-content: space-between;
		gap: $space-md;
		.Button {
			display: inline-flex;
			margin: 0;
		}
	}
	@media print {
		.ReportPrint-instructions {
			display: none;
		}
	}
	.ReportPrint-heading {
		display: flex;
		align-items: baseline;
		justify-content: space-between;
		gap: $space-lg;
	}
	.Divider {
		border: none;
		border-bottom: 1pt solid $color-neutral-1;
	}
}
</style>
